import { isMarkupWithoutText } from '@/common/helpers/isMarkupWithoutText/isMarkupWithoutText';

export function clearEmptyMarkup(markup: string): string {
  return isMarkupWithoutText(markup) ? '' : markup.trim();
}
